import Cookies from 'js-cookie';
import { debug } from 'utils/debug';

export const getAllRelatedCookies = (name: string) => {
  return Object.keys(Cookies.get()).filter((cookie) => cookie.includes(name));
};

export const getCookieValue = (name: string) => {
  return Cookies.get(name) || null;
};

export const setCookieValue = (name: string, value: string) => {
  Cookies.set(name, value, { path: '/', expires: 365 });
};

export const removeAllRelatedCookies = (name: string, domains?: string[]) => {
  getAllRelatedCookies(name).forEach((cookie) => {
    removeCookie(cookie, domains);
  });
};

export const removeCookie = (name: string, domains?: string[]) => {
  if (!getCookieValue(name)) {
    return;
  }

  const { hostname } = window.location;
  const baseHostname = hostname.startsWith('www.')
    ? hostname.substring(4)
    : hostname;

  const possibleDomains = [
    undefined,
    hostname,
    `.${hostname}`,
    baseHostname,
    `.${baseHostname}`,
    '.letsway.com',
  ];

  if (domains?.length) {
    possibleDomains.push(...domains);
  }

  // Attempt removal with each domain combination. Sometimes cookies can have
  // the same name but different domains.
  possibleDomains.forEach((domain) => {
    const options: Cookies.CookieAttributes = { path: '/' };
    if (domain) {
      options.domain = domain;
    }
    Cookies.remove(name, options);
  });

  if (getCookieValue(name)) {
    debug(
      'warn',
      `Failed to remove cookie: ${name}, is the domain and path correct?`,
    );
  }
};

export const sanitizeWildcardCookieName = (name: string) => {
  return name.replace('*', '').trim();
};

export const hasWildcardCookieName = (name: string) => {
  return name.includes('*');
};
